import Schema from 'AppReact/schema';
import { subtitle } from 'modals/trainingVideoModal/types/trainingVideoModal';

export default {
  subtitles: Schema(subtitle, 'array', { defaultValue: [] }),
}
